import React from "react";
import "../Components/BlogBanner.scss";
import { Link } from "react-router-dom";

function BlogBanner(props) {
  return (
    <div className="blog_banner_con">
      <div className="blog_banner_text">
        <h3>Elevate your Networking</h3>
        <p>
          One platform to save, manage & convert
          <br /> networking leads
        </p>
        <img
          src="https://leapon-media.s3.amazonaws.com/media/webp_images/Logo_png.webp"
          alt="Leapon"
        />
      </div>
      <Link
        to={
          props.cta === "Book a Demo"
            ? "/get-demo#demo-booking"
            : "https://leapon.me/signup/"
        }
        className="cta-btn"
        target="_blank"
      >
        {props.cta}
      </Link>
    </div>
  );
}

export default BlogBanner;
